import { render, staticRenderFns } from "./PAF_sale.vue?vue&type=template&id=2e5ad69d&scoped=true"
import script from "./PAF_sale.vue?vue&type=script&lang=js"
export * from "./PAF_sale.vue?vue&type=script&lang=js"
import style0 from "./PAF_sale.vue?vue&type=style&index=0&id=2e5ad69d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5ad69d",
  null
  
)

export default component.exports